import { render } from "./PreviewImage.vue?vue&type=template&id=5acb021c&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"

import "./PreviewImage.vue?vue&type=style&index=0&id=5acb021c&scoped=true&lang=css"

import exportComponent from "/Volumes/Work/1Gate/1Gate/1gate_check_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb021c"]])

export default __exports__